import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import { Link } from '@router/Link';

import styles from './styles.module.scss';

function SignUpText() {
  return (
        <Column className={styles.container}
                align='center'
                fullWidth
                spacing={12}>
            <Row spacing={56} fullWidth>
                <div className={styles.line} />
                <Text size='lg'>또는</Text>
                <div className={styles.line} />
            </Row>
            <Link activityName='SignUpActivity'
                  activityParams={{}}>
                <Text size='lg' fontWeight='bold'>
                    회원가입
                </Text>
            </Link>
        </Column>
  );
}

export default SignUpText;
